export { appConfig } from './appConfig';
export { headerConfig } from './headerConfig';



// WEBPACK FOOTER //
// ./src/app/config/index.js